// Custom words dialog component for the library page

import React from 'react';
import CustomWordsEditor from '../moderation/CustomWordsEditor';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const CustomWordsDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  censorship,
  setDialog,
}) => {
  return (
    <Dialog
      open={dialog === 'custom-words'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'custom-words' : null)}
    >
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Custom Words</DialogTitle>
          <DialogDescription>
            Add words or phrases you always want censored in your hosted rooms.
          </DialogDescription>
        </DialogHeader>
        <CustomWordsEditor
          modSettings={censorship.modSettings}
          setModSettings={censorship.setModSettings}
          markDirty={censorship.markDirty}
          canEdit={!!user}
          onRequireAuth={censorship.requireAuth}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CustomWordsDialog;
